import { useEffect, useState } from 'react';

function validarCPF(cpfValida: string): boolean {
  cpfValida = cpfValida.replace(/[^\d]+/g, ''); // Remove os caracteres não numéricos da string

  if (cpfValida.length < 11) return false;

  const cpfArr = cpfValida.split('').map((e) => parseInt(e));

  // Verifica se todos os dígitos são iguais (CPF inválido)
  //if (/^(\d)\1+$/.test(cpfValida)) return false;
  const primeiroDigitoCPF = cpfArr[0];
  let digitoDiferenteCPF = false;

  for (let i = 1; i < cpfArr.length; i++) {
    if (cpfArr[i] !== primeiroDigitoCPF) {
      digitoDiferenteCPF = true;
    }
  }

  if (!digitoDiferenteCPF) return false;

  // Calcula e verifica os dígitos verificadores

  // Verificação do primeiro dígito verificador: XXX.XXX.XXX-_X
  let sum = 0;
  let resto = 0;

  for (let i = 0; i < 9; i++) {
    sum += cpfArr[i] * (10 - i);
  }

  resto = (sum * 10) % 11;

  if (resto == 10) resto = 0;
  if (resto !== cpfArr[9]) return false;

  //verificação do segundo dígito verificador: XXX.XXX.XXX-X_
  sum = 0;

  for (let i = 0; i < 10; i++) {
    sum += cpfArr[i] * (11 - i);
  }

  resto = (sum * 10) % 11;

  if (resto == 10) resto = 0;
  if (resto !== cpfArr[10]) return false;

  return true; // CPF válido
}

export const useCpfValidation = ({ cpf = '' }) => {
  const [validCpf, setValidCpf] = useState<boolean>(false);

  useEffect(() => {
    setValidCpf(validarCPF(cpf));
  }, [cpf]);

  return [validCpf];
};
